<script setup lang="ts">
import PanelGroup from '../PanelGroup.vue'
import {
  COMING_SOON_HOME_BLOCKS,
  isHiddenHomeBlock,
  visibleHomeBlocks,
  type HomeBlockId
} from '../../lib/brandAppContract'
import { HOME_BLOCK_SECTIONS } from '../../lib/brandAppSections'
import useBrandAppConfig from '../../composables/useBrandAppConfig'
import OrderedSubsetList from '../OrderedSubsetList.vue'

defineProps<{ highlightId?: string | null; title?: string }>()

const { home, homeBlockOrder, setHomeBlocks, setHomeBlockOrder } = useBrandAppConfig()

const { t } = useI18n()

const items = computed(() =>
  visibleHomeBlocks().map((block) => ({ id: block.id, label: block.label, icon: HOME_BLOCK_SECTIONS[block.id].icon }))
)

const visibleBlocks = computed(() => home.value.blocks.filter((id) => !isHiddenHomeBlock(id)))

const updateBlocks = (blocks: HomeBlockId[]) =>
  setHomeBlocks([...blocks, ...home.value.blocks.filter(isHiddenHomeBlock)])

const updateOrder = (order: HomeBlockId[]) =>
  setHomeBlockOrder([...order, ...homeBlockOrder.value.filter(isHiddenHomeBlock)])
</script>

<template>
  <PanelGroup :title="title">
    <div class="flex flex-col gap-3">
      <OrderedSubsetList
        :items="items"
        :model-value="visibleBlocks"
        :order="homeBlockOrder"
        :highlight-id="highlightId"
        :disabled-ids="COMING_SOON_HOME_BLOCKS"
        :disabled-hint="t('pages.loyaltySupports.webapp.editor.screens.comingSoon')"
        @update:model-value="updateBlocks"
        @update:order="updateOrder"
      />
      <p class="text-muted-foreground text-xs">
        {{ t('pages.loyaltySupports.webapp.editor.structure.home.hint') }}
      </p>
    </div>
  </PanelGroup>
</template>
